/* eslint one-var: [0]*/
import Utils from '../utils/utils.js';

export default class ReminderModal {
	constructor( settings ){
		this.container = typeof settings === 'object' ? settings.container : document.body;
		this.init();
	}

	init( ){
		this.addEvents();
	}
  
	addEvents(){
		jQuery( this.container ).on( 'click.oax::open-reminder', '.js--reminder-modal', jQuery.proxy( this.onReminderButton, this ) );
	}
  
	removeEvents(){
		jQuery( this.container ).off( 'click.oax::open-reminder', '.js--reminder-modal', jQuery.proxy( this.onReminderButton, this ) );
	}

	onReminderButton( event ){
		const $el = jQuery( event.target ).is( 'a' ) ? jQuery( event.target ) : jQuery( event.target ).closest( 'a' );

		if ( $el.hasClass( 'is-open' ) ){
			this.close( $el );
		} else {
			this.open( $el );
		}

		event.preventDefault();    
	}
  
	buildModal( $el ){
		const $modal = jQuery( '<div class="c-reminder-modal fixed z-overlay"></div>' ),
			$modalInner = jQuery( '<div class="c-reminder-modal__inner"></div>' ),
			$modalClose = jQuery( '<button class="c-btn-size absolute top-0 right-0 bg-white text:black">X</button>' ),
			$modalTitle = jQuery( `<h2 class="mt-0 mb-15 text-md">${$el.data( 'modalTitle' )}</h2>` ),
			$iCalLink = jQuery( `<a href="${$el.data( 'ical' )}" class="no-barba block mb-1 no-underline" target="_blank"><span class="ml-05">iCal</span></a>` ),
			$googleCalLink = jQuery( `<a href="${$el.data( 'googlecal' )}" class="no-barba block no-underline mb-1" target="_blank"><span class="ml-05">Google Kalender</span></a>` ),
			googleCalIcon = `<svg xmlns="http://www.w3.org/2000/svg" class="w-15 h-15" viewBox="0 0 511.999 511.999"><path fill="#e6e6e6" d="M455.617 10.846H56.367c-12.437 0-22.517 10.094-22.517 22.531v74.912h444.296V33.377c.001-12.438-10.093-22.531-22.529-22.531zM148.16 55.922c-5.953 0-10.784-4.831-10.784-10.784s4.831-10.784 10.784-10.784 10.784 4.831 10.784 10.784-4.832 10.784-10.784 10.784zm218.496 0c-5.953 0-10.784-4.831-10.784-10.784s4.831-10.784 10.784-10.784 10.784 4.831 10.784 10.784-4.832 10.784-10.784 10.784z"/><path fill="#3a5bbc" d="M511.505 113.523l-34.077 177.704 13.918 184.793c1.021 13.559-9.706 25.134-23.322 25.134H43.96c-13.602 0-24.343-11.575-23.322-25.134l13.933-184.793L.494 113.523C-2.712 96.815 10.099 81.3 27.123 81.3h457.74c17.038 0 29.848 15.515 26.642 32.223z"/><path fill="#518ef8" d="M468.024 501.153H43.96c-13.602 0-24.343-11.575-23.322-25.134l13.933-184.793h442.858l13.918 184.793c1.021 13.559-9.706 25.134-23.323 25.134z"/><g fill="#fff"><path d="M247.371 244.856c0-34.687-29.026-62.906-64.703-62.906s-64.703 28.219-64.703 62.906h21.568c0-22.794 19.351-41.338 43.136-41.338s43.136 18.544 43.136 41.338-19.351 41.338-43.136 41.338h-20.13v21.568h20.13c23.785 0 43.136 18.544 43.136 41.338s-19.351 41.338-43.136 41.338-43.136-18.544-43.136-41.338h-21.568c0 34.687 29.026 62.906 64.703 62.906s64.703-28.219 64.703-62.906c0-21.663-11.322-40.802-28.513-52.122 17.192-11.319 28.513-30.459 28.513-52.122zM289.289 218.704l11.064 18.514 42.636-25.477v189.481h21.567V173.728z"/></g></svg>`,
			iCalIcon = `<svg xmlns="http://www.w3.org/2000/svg" class="w-15" viewBox="0 0 725.1 711"><path fill="#565656" d="M705 616.3l-589.9 94.4c-13.1 2.1-25.4-6.8-27.5-19.9L.3 145.7c-2.1-13.1 6.8-25.4 19.9-27.5l589.9-94.4c13.1-2.1 25.4 6.8 27.5 19.9l87.2 545.1c2.2 13.1-6.7 25.4-19.8 27.5z"/><path fill="none" d="M577.1 590.8"/><path fill="#FFF" d="M577.1 590.8l87.3-124.5L589.7 0 32.8 89.1l91.9 574.1 452.4-72.4M577.1 590.8"/><path fill="#FFF" d="M577.1 590.8l87.3-124.5-104.6 16.8 17.3 107.7"/><path fill="#EA5750" d="M32.803 89.065L589.697-.047l28.06 175.362-556.893 89.112z"/><g fill="#FFF"><path d="M215.8 179.8c1.6 8 8.1 13.5 19.2 11.7 11.8-1.9 16.6-10 14.2-24.6l-12.1-73.1 11.2-1.9 12.1 73.1c3.4 20.5-5.3 33.7-23.7 36.7-17 2.8-29.6-6-31.9-20.2l11-1.7zM294.5 153.4c2.8 16.8 15.1 25.9 31.9 23.1 16.8-2.8 25.5-15.4 22.8-32.1l-11.1-67.2 11.1-1.8 11.3 68.7c3.5 21.4-8.2 38.8-32.4 42.8-24.1 4-40.9-8.7-44.4-30.1L272.3 88l11.1-1.8 11.1 67.2zM450.4 164.3l-59.8 9.9-17-102.9 11.2-1.9 15.3 92.7 48.5-8 1.8 10.2z"/></g><g fill="#2B2B2B"><path d="M302.4 553.7l-25.9-156.9-56.8 9.4-3.5-21c7.4-1.2 14.5-3 21.3-5.3s12.8-5.4 17.9-9.5c5.1-4 9.2-9 12.3-15 3-6 4.6-13.2 4.7-21.7l20.1-3.3 36.2 218.9-26.3 4.4zM491 364.6c-7.2 16.6-13.1 34.1-17.8 52.4-4.7 18.3-7.9 36.9-9.7 55.8-1.7 18.9-1.7 37 .1 54.2l-29.3 4.8c-1.8-18.7-1.8-37.3.2-55.7 1.9-18.4 5.4-36.3 10.3-53.7s11.2-34.2 18.8-50.2c7.6-16.1 16.2-31.1 25.7-45.2l-115 19.1-4.1-24.7L511.9 298l3.7 22.5c-9.2 12.8-17.5 27.4-24.6 44.1z"/></g><path fill="#EAEAEA" d="M577.1 590.8l-17.3-107.7 104.6-16.8z"/></svg>`,
			$facebookEventLink = typeof $el.attr( 'data-facebook' ) !== typeof undefined && $el.attr( 'data-facebook' ) !== false ? jQuery( `<a href="${$el.data( 'facebook' )}" class="no-barba block no-underline" target="_blank"><svg class="w-15 h-15 fill-current"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-social-fb"></use></svg><span class="ml-05">Facebook</span></a>` ) : false,
			currentPosEl = {
				top: $el.offset().top - jQuery( document ).scrollTop(),
				left: $el.offset().left
			},
			currentDimEl = {
				width: window.getComputedStyle( $el.get( 0 ), null ).getPropertyValue( 'width' ),
				height: window.getComputedStyle( $el.get( 0 ), null ).getPropertyValue( 'height' )
			},
			currentBGColor = $el.css( 'backgroundColor' );

		gsap.set( $modal, {
			left: currentPosEl.left,
			top: currentPosEl.top,
			width: currentDimEl.width,
			height: currentDimEl.height,
			backgroundColor: currentBGColor,
			autoAlpha: 0 
		} );

		$modalInner.append( $modalClose );
		
		$modalInner.append( $modalTitle );

		$iCalLink.prepend( iCalIcon );
		$modalInner.append( $iCalLink );
		
		$googleCalLink.prepend( googleCalIcon );
		$modalInner.append( $googleCalLink );
		
		if ( $facebookEventLink !== false ){
			$modalInner.append( $facebookEventLink );
		}		
		$modal.append( $modalInner );

		gsap.set( $modalInner.children(), {
			autoAlpha: 0
		} );

		const $reminderModalBackdrop = $( '<div class="c-reminder-modal__backdrop fixed w-full h-full left-0 top-0" style="background-color: rgba(255,255,255,0.4); opacity: 0; visibility: hidden; z-index: 9999998;"></div>' );
		$( 'body' ).append( $reminderModalBackdrop );
		jQuery( 'body' ).append( $modal );

		this.$buttonEl = $el;
		this.reminderModalSelector = '.c-reminder-modal';
		this.reminderModalBackdropSelector = '.c-reminder-modal__backdrop';
		this.$reminderModalBackdrop = $reminderModalBackdrop;
		this.$reminderModal = $modal;
		this.$reminderModalInner = $modalInner;
		this.$reminderModalClose = $modalClose;
	}
  
	buildTimeline( $el ){
		const self = this,
			tlOpen = gsap.timeline( {
				paused: true,
				onComplete(){
					jQuery( document ).on( 'click.oax::close-reminder-modal', jQuery.proxy( self.close, self ) );
				}
			} );

		tlOpen
			.to( this.$reminderModalBackdrop, {
				autoAlpha: 1,
				duration: 0.3
			} )
			.to( this.$reminderModal, {
				autoAlpha: 1,
				duration: 0.3
			}, '-=.0.3' )
			.set( $el, {
				autoAlpha: 0
			} )	
			.to( this.$reminderModal, {
				duration: 0.5,
				left: '50%',
				top: '50%',
				y: '-50%',
				x: '-50%',
				width: Utils.isMobile() ? window.getComputedStyle( $el.get( 0 ), null ).getPropertyValue( 'width' ) : 500,
				height: window.getComputedStyle( this.$reminderModalInner.get( 0 ), null ).getPropertyValue( 'height' )
			} )
			.to( this.$reminderModalInner.children(), {
				duration: 0.3,
				autoAlpha: 1
			} );
		
		this.tlOpen = tlOpen;
	}
  
	remove(){
		this.$reminderModal.remove();
		this.$reminderModalBackdrop.remove();
		jQuery( document ).off( 'click.oax::close-reminder-modal', jQuery.proxy( this.close, this ) );
	}
  
	open( $el ){
		this.buildModal( $el );
		
		/*
		 * if ( jQuery( this.container ).find( '.c-event-single' ).hasClass( 'c-event-single--init' ) ){
		 * Utils.scrollLock( true );
		 * } else {
		 * jQuery( this.container ).css( 'overflow', 'hidden' );
		 * }
		 */

		// Utils.disableLinks( jQuery( '.c-reminder-modal' ) );		

		this.buildTimeline( $el );		
		this.tlOpen.play();
	}

	close( $el ){
		const self = this;
		let target = document.body;

		if ( typeof event !== 'undefined' ){
			target = event.target;
		}

		if ( jQuery( target ).closest( self.reminderModalSelector ).length === 0 || jQuery(target).is( self.$reminderModalClose ) ) {	// eslint-disable-line
			// this.tlOpen.reverse();
			gsap.to( self.reminderModalBackdropSelector, {
				autoAlpha: 0,
				duration: 0.5,
			} );
			gsap.to( self.reminderModalSelector, {
				duration: 0.5,
				y: '-45%',
				autoAlpha: 0,
				onComplete(){
					self.remove();
					gsap.to( self.$buttonEl, {
						autoAlpha: 1,
						duration: 0.3,						
					} );
				}
			} );
		}
	}

	destroy(){
		this.removeEvents();
	}
}
